import _, { get, set } from "lodash";
import { Select, Input, Cascader } from "antd";
import React from "react";

const required = <span style={{ color: "red", marginRight: 4 }}>*</span>;

export const getcolumns = (props) => {
  let { dictionary, contactSelectChange, iptChange, disabled } = props;
  return [
    {
      title: <span>{required}联系人类别</span>,
      dataIndex: "category",
      key: "category",
      align: "center",
      render: (text, record, index) => {
        return (
          <span>
            {/* {required} */}
            <Select
              allowClear
              placeholder="请选择"
              onChange={() => {
                contactSelectChange(index);
              }}
              value={text}
              disabled={
                ["BusinessContact", "OrderContact"].includes(text) || disabled
              }
              style={{ width: 200 }}
              options={get(dictionary, "contact_category_dict")}
            ></Select>
          </span>
        );
      },
    },
    {
      title: <span>{required}联系人姓名</span>,
      dataIndex: "contact_name",
      key: "contact_name",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            {/* {required} */}
            <Input
              allowClear
              value={text}
              onChange={(e) => {
                iptChange(index, e);
              }}
              disabled={disabled}
              name="contact_name"
              placeholder="请输入联系人姓名"
              style={
                record.contact_nameErr
                  ? { width: 200, borderColor: "red" }
                  : { width: 200 }
              }
            />
            {record.contact_nameErr && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  top: 32,
                  left: 47,
                }}
              >
                请输入联系人姓名
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: <span>{required}联系手机</span>,
      dataIndex: "phone",
      key: "phone",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              allowClear
              // maxLength={11}
              value={text}
              disabled={disabled}
              onChange={(e) => {
                iptChange(index, e);
              }}
              name="phone"
              placeholder="请输入联系手机"
              style={
                record.phoneErr
                  ? { width: 200, borderColor: "red" }
                  : { width: 200 }
              }
            />
            {record.phoneErr && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  top: 32,
                  left: 47,
                }}
              >
                请输入手机号
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "固定电话",
      dataIndex: "tel",
      key: "tel",
      align: "center",
      render: (text, record, index) => {
        return (
          <Input
            allowClear
            value={text}
            disabled={disabled}
            onChange={(e) => {
              iptChange(index, e);
            }}
            name="tel"
            placeholder="请输入固定电话"
            style={{ width: 200 }}
          />
        );
      },
    },
    {
      title: <span>{required}邮箱</span>,
      dataIndex: "email",
      key: "email",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            {/* {required} */}
            <Input
              allowClear
              value={text}
              disabled={disabled}
              onChange={(e) => {
                iptChange(index, e);
              }}
              name="email"
              placeholder="请输入邮箱"
              style={
                record.emailErr
                  ? { width: 200, borderColor: "red" }
                  : { width: 200 }
              }
            />
            {
              // record.emailErr && <div style={{ position: "absolute", color: "red", fontSize: 10, top: 32, left: 47 }}>请输入正确的邮箱地址</div>
              record.emailErr && (
                <div
                  style={{
                    position: "absolute",
                    color: "red",
                    fontSize: 10,
                    top: 32,
                    left: 47,
                  }}
                >
                  请输入邮箱地址
                </div>
              )
            }
          </div>
        );
      },
    },
  ];
};

export const getcolumns2 = (props) => {
  let {
    setGNTAddress,
    columns2BankNameChange,
    columns2IptChange,
    columns2BankFullNmeChange,
    bankNameOptions,
    finceArea,
    disabled,
    getBankOptions,
  } = props;
  return [
    {
      title: "银行账号",
      dataIndex: "bank_account",
      key: "bank_account",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              allowClear
              value={text}
              disabled={disabled}
              onChange={(e) => {
                columns2IptChange(index, e);
              }}
              name="bank_account"
              placeholder="银行账号"
              style={
                record.bank_account_err
                  ? { width: 180, borderColor: "red" }
                  : { width: 180 }
              }
            />
            {record.bank_account_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请输入银行账号
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "账户名称",
      dataIndex: "account_name",
      key: "account_name",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              allowClear
              value={text}
              disabled={disabled}
              onChange={(e) => {
                columns2IptChange(index, e);
              }}
              name="account_name"
              placeholder="账户名称"
              style={
                record.account_name_err
                  ? { width: 180, borderColor: "red" }
                  : { width: 180 }
              }
            />
            {record.account_name_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请输入账户名称
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "开户银行",
      dataIndex: "bank_name",
      key: "bank_name",
      align: "center",
      render: (text, record, index) => {
        return (
          <div>
            <Select
              allowClear
              showSearch
              filterOption={(input, option) => {
                return (option.children || "")
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              disabled={disabled}
              placeholder="开户银行"
              onChange={(val) => {
                columns2BankNameChange(index, val);
              }}
              value={text || null}
              style={
                record.bank_name_err
                  ? { width: 200, border: "1px solid red" }
                  : { width: 200 }
              }
            >
              {_.get(bankNameOptions, "length") > 0 &&
                bankNameOptions.map((item, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={item.bank_name + "/" + item.bank_code}
                    >
                      {item.bank_name}
                    </Select.Option>
                  );
                })}
            </Select>
            {record.bank_name_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-5%",
                  left: "10%",
                }}
              >
                请选择开户银行
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "开户省市",
      dataIndex: "bank_province_city",
      key: "bank_province_city",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Cascader
              allowClear={false}
              disabled={disabled}
              value={
                record.province
                  ? [record.province, record.city]
                  : []
              }
              style={
                record.account_name_err ? { border: "1px soilid red" } : {}
              }
              options={finceArea || []}
              fieldNames={{
                label: "name",
                value: "name",
                children: "districts",
              }}
              onChange={(value, selectedOptions) => {
                setGNTAddress(index, value, selectedOptions);
              }}
              placeholder="请选择省市"
            />
            {record.bank_province_city_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请选择省市
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "开户银行全称",
      dataIndex: "bank_full_name",
      key: "bank_full_name",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Select
              showSearch
              allowClear
              placeholder="请选择"
              disabled={disabled}
              onClick={() => {
                getBankOptions(index);
              }}
              onChange={(value) => {
                columns2BankFullNmeChange(index, value);
              }}
              value={record.bank_full_name}
              filterOption={(input, option) => {
                return (option.children || "")
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              style={
                record.bank_full_name_err
                  ? { border: "1px solid red", width: 350 }
                  : { width: 350 }
              }
            >
              {_.get(record, "bankNumberOption.length") > 0 &&
                record.bankNumberOption.map((item, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={item.collectionfullopeningbank}
                    >
                      {item.collectionfullopeningbank}
                    </Select.Option>
                  );
                })}
            </Select>
            {record.bank_full_name_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请选择开户银行全称
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "联行号",
      dataIndex: "united_bank_code",
      key: "united_bank_code",
      align: "center",
      render: (text, record, index) => {
        return <Input value={text} disabled={true} style={{ width: 120 }} />;
      },
    },
  ];
};

export const getcolumns3 = (props) => {
  let { setOutAccountCurency, columns3IptChange, dictionary, disabled } = props;
  return [
    {
      title: "币种",
      dataIndex: "currency",
      key: "currency",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Select
              style={
                record.currency_err
                  ? { width: 120, borderColor: "red" }
                  : { width: 120 }
              }
              value={text || null}
              allowClear
              placeholder="请选择"
              disabled={disabled}
              onChange={(value) => {
                setOutAccountCurency(index, value);
              }}
            >
              {_.get(dictionary, "currency_dict.length") > 0 &&
                dictionary.currency_dict.map((item, index) => {
                  return (
                    <Select.Option key={index} value={item.dict_key}>
                      {item.dict_name}
                    </Select.Option>
                  );
                })}
            </Select>
            {record.currency_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请选择币种
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "银行账号",
      dataIndex: "bank_account",
      key: "bank_account",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              value={text}
              allowClear
              disabled={disabled}
              onChange={(value) => {
                columns3IptChange(index, value);
              }}
              name="bank_account"
              placeholder="银行账号"
              style={
                record.bank_account_err
                  ? { width: 180, borderColor: "red" }
                  : { width: 180 }
              }
            />
            {record.bank_account_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请输入银行账号
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "账户名称",
      dataIndex: "account_name",
      key: "account_name",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              value={text}
              allowClear
              disabled={disabled}
              onChange={(value) => {
                columns3IptChange(index, value);
              }}
              name="account_name"
              placeholder="账户名称"
              style={
                record.account_name_err
                  ? { width: 180, borderColor: "red" }
                  : { width: 180 }
              }
            />
            {record.account_name_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请输入账户名称
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "开户银行全称",
      dataIndex: "bank_full_name",
      key: "bank_full_name",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              value={text}
              allowClear
              disabled={disabled}
              onChange={(value) => {
                columns3IptChange(index, value);
              }}
              name="bank_full_name"
              placeholder="开户银行全称"
              style={
                record.bank_full_name_err
                  ? { width: 180, borderColor: "red" }
                  : { width: 180 }
              }
            />
            {record.bank_full_name_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请输入开户银行全称
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "开户银行地址",
      dataIndex: "bank_address",
      key: "bank_address",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              value={text}
              allowClear
              disabled={disabled}
              onChange={(value) => {
                columns3IptChange(index, value);
              }}
              name="bank_address"
              placeholder="开户银行地址"
              style={
                record.bank_address_err
                  ? { width: 180, borderColor: "red" }
                  : { width: 180 }
              }
            />
            {record.bank_address_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请填写开户银行地址
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "公司地址",
      dataIndex: "company_address",
      key: "company_address",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              value={text}
              allowClear
              disabled={disabled}
              onChange={(value) => {
                columns3IptChange(index, value);
              }}
              name="company_address"
              placeholder="公司地址"
              style={
                record.company_address_err
                  ? { width: 180, borderColor: "red" }
                  : { width: 180 }
              }
            />
            {record.company_address_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请填写公司地址
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "SWIFT号",
      dataIndex: "swift_code",
      key: "swift_code",
      align: "center",
      render: (text, record, index) => {
        return (
          <div style={{ position: "relative" }}>
            <Input
              onChange={(value) => {
                columns3IptChange(index, value);
              }}
              placeholder="SWIFT号"
              allowClear
              name="swift_code"
              disabled={disabled}
              style={
                record.swift_code_err
                  ? { width: 120, borderColor: "red" }
                  : { width: 120 }
              }
              value={text}
            />
            {record.swift_code_err && (
              <div
                style={{
                  position: "absolute",
                  color: "red",
                  fontSize: 10,
                  bottom: "-62%",
                  left: "4%",
                }}
              >
                请填写SWIFT号
              </div>
            )}
          </div>
        );
      },
    },
  ];
};

export const isNotArr = [
  { label: "是", value: true },
  { label: "否", value: false },
];
export const isNotArr2 = [
  { label: "实物投诉", value: "has_goods_complaint" },
  { label: "无实物投诉", value: "no_goods_complaint" },
  { label: "不支持投诉", value: "not_support" },
];
export const claimRuletArr = [
  {
    label: "按实际产生索赔",
    value: "actual_produce",
  },
  {
    label: "按固定产生索赔",
    value: "fixed_ratio",
  },
];
export const claimhandlingmethodArr = [
  {
    label: "退货",
    value: "return_goods",
  },
  {
    label: "换货",
    value: "exchange_goods",
  },
  {
    label: "补贴",
    value: "subsidy",
  },
];
export const titleObj = {
  manage_property_key: "经销：货权属于视客    代销：货权属于供应商",
  operation_mode_key: "请按照《医疗器械经营许可证》选择",
  purchase_cycle: "给工厂下订单至供应商入库时间",
  estimate_date: "供应商发货到视客入库时间",
  statement_mode_key: (
    <div>
      <div>
        固定账期（月结）：结算起点是每一笔交易发生时间所在月的最后一天+固定X天
      </div>
      <div>
        固定账期（季结）：结算起点是每一笔交易发生时间所在季度的最后一天+固定X天
      </div>
      <div>滚动账期：结算起点是每一笔交易发生时间+固定X天</div>
    </div>
  ),
};



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/supplierinformationentry/config.js